export enum UserMentionPlaceholderEnum {
  firstName = '[first_name]',
  mention = '[mention]',
  user = '[user]',
}
